module.exports = "https://static.wmbcdn.com/uniweb/images/d3bd3fda3ae03a3af607bc0470b401d2.svg";